export default __webpack_public_path__ + "static/disability-confident-employer-8b1e6996f03e4e689368b456f4e1e298.png";